const REQUIRED_VALUE = 'Provide a valid {{label}}'
const SPECIAL_CHAR = 'Please remove special characters'

export default {
  required: REQUIRED_VALUE,
  dropRequire: REQUIRED_VALUE,
  compare: "{{label}} doesn't match",
  matches: 'The {{label}} field does not match the {{label}} field.',
  email: REQUIRED_VALUE,
  min: 'The {{label}} field must be at least {{length}} characters in length.',
  max: 'The {{label}} field must not exceed {{length}} characters in length.',
  exact: 'The {{label}} field must be exactly {{length}} characters in length.',
  greaterThan:
    'The {{label}} field must contain a number greater than {{label}}.',
  lessThan: 'The {{label}} field must contain a number less than {{label}}.',
  alpha: 'The {{label}} field must only contain alphabetical characters.',
  alphaNumeric:
    'The {{label}} field must only contain alpha-numeric characters.',
  alphaDash:
    'The {{label}} field must only contain alpha-numeric characters, underscores, and dashes.',
  numeric: 'The {{label}} field must contain only numbers.',
  integer: 'The {{label}} field must contain an integer.',
  decimal: 'The {{label}} field must contain a decimal number.',
  phone: REQUIRED_VALUE,
  phoneMask: REQUIRED_VALUE,
  zipcode: REQUIRED_VALUE,
  poBox: 'Shipping to PO Box, mailbox, and APO/FPO addresses are not supported',
  reCaptcha: 'Verification failed. Please try again.',
  validChar: SPECIAL_CHAR,
  letter: 'Should contain at least 1 letter',
}
